import React, { useState ,useEffect} from "react";
import CircleImage from "olive-react-myoneui/lib/CircleImage";
import {iconStar, thumbsUpIcon} from "../../../constants/icons";
import axios from "axios";
import moment from "moment";
import { API_URL } from '../../../constants/config';

function ReviewsAndRatings({ className,coursedetails }) {
    const btnshow = (coursedetails.bundle.course_reviews.count > coursedetails.bundle.course_reviews.limit) ? true : false;
    const [review,setReview] = useState(coursedetails.bundle.course_reviews.reviews || []);
    const [limit, setLimit] = useState(5);
    const [offset, setoffset] = useState(5);
    const [visibleButton, setVisibleButton] = useState(btnshow);

    const loadMore = () => {

      const fetchReviewData = async () => {
        try {
          const data = new URLSearchParams();
          data.append('bundle_id', coursedetails.bundle_id);
          data.append('limit', limit);
          data.append('offset', offset);

          const config = {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          };

          const response = await axios.post(`${API_URL}api/bundle/load_reviews`, data, config);
          const reviewData = await response.data.reviews;
          setVisibleButton(response.data.show_load_button);
          setReview([...review, ...reviewData]);
          
        } catch(err) {
          console.error('Error:', err);
        }  
      };

      fetchReviewData();

      setoffset(offset + limit);
    }
    
    // console.log(coursedetails?.bundle_id,"coursedetails")
    // useEffect(() => {
    //   setReview(coursedetails?.bundle.course_reviews)
    // }, [coursedetails]);

  const firstletter = (args) => {
    let text = args;
    let letter = text.charAt(0);
    return letter
  }

  var array = []
  const iconStarfn = (args) => {
    array = []
    for(let i = 0; i < args; i++ ){
      array.push(iconStar)
    }
    return array
  }

  var localeData = moment.updateLocale('en', {
    relativeTime: {
        future: "in %s",
        past: "%s",
        s: 'Just now',
        ss: '%d seconds',
        m: "%d min ago",
        mm: "%d min ago",
        h: "%d hours ago",
        hh: "%d hours ago",
        d: "%d days ago",
        dd: "%d days ago",
        M: "%d months ago",
        MM: "%d months ago",
        y: "a year",
        yy: "%d years"
    }
  });

  // console.log(review,"review")

  const changeDate = (args) => {
    // console.log(args,"date")
    
    if(args){
      var now = moment(new Date()); //todays date
      var end = moment(args); // another date
      var duration = moment.duration(now.diff(end));
      var days = duration.asDays();
      // console.log(days,"days")
      const date = moment.utc(args).local().startOf('seconds').fromNow()
      return date
      // if(days > 1){
      //   const date = moment.utc(args).local().startOf('seconds').fromNow()
      //   return date
      // }
      // else{
      //   const date = moment.utc(args).local().startOf('seconds').fromNow()
      //   return date
      // }
    }  
  }

  // const thumbsuphandler = (args) => {
  //   console.log(API_URL,"API_URL")

  //   var data = {
  //     "bundle_id": coursedetails?.bundle_id,
  //     "status": args,
  //   }
  //   axios.post(`${API_URL}api/material/bundle_rating_helpful`,data, )
  //   .then((response) => {
  //   console.log(response)
  //   });
  // }

  const round = (args) => {
    return Math.round(args)
  }

  return (
    <div className={`${className || ""} mk-review-rating-wrapper`}>
      <div className="mk-rating-average d-flex align-items-center gap-1">
        <span className="d-flex mk-icon-star">{iconStar}</span>
        <div className="d-flex align-items-center gap-1"><span>{round(coursedetails?.bundle.total_ratting)} course rating</span><span className="mk-ratings-count">({coursedetails?.bundle.course_reviews.count} ratings)</span></div>
      </div>

      {/* {review && review?.reviews.map((value) => (
        <div className="mk-review-block-wrapper">
        <div className="mk-review-block d-flex align-items-start">
          <CircleImage className="circle-wrap circle-wrap-md bg-circle-dark text-white mk-name-abbr">
            {firstletter(value.cc_user_name)}
          </CircleImage>
          <div className="mk-review-content">
            <h1 className="mk-reviewer-name mb-1">{value.cc_user_name}</h1>
            <div className="mk-ratings-individual d-flex gap-2">
              <span className="d-flex gap-1 mk-stars">
              {iconStarfn(value.cc_rating)}
              </span>
              
              <span className="mk-rating-time">{changeDate(value.created_date)}</span>
            </div>
            <div className="mk-review-copy">
              <p>{value.cc_reviews}</p>
            </div>
          </div>
        </div>
        <div className="mk-comment-feeds d-flex justify-content-end">
          {/* <div className="d-flex align-items-center gap-3 mk-feeds-btns">
            <span className="mk-feed-title me-1">Helpful?</span>
            <div className="d-flex align-items-center gap-4">
              <span className="mk-feeds-thumbs me-1" onClick={() => thumbsuphandler("up")}>{thumbsUpIcon}</span>
              <span className="mk-feeds-thumbs mk-feeds-thumbsdown" onClick={() => thumbsuphandler("down")}>{thumbsUpIcon}</span>
            </div>
          </div> *}
        </div>
      </div>

      ))
      } */}

      {review && review?.map((value) => (
        <div className="mk-review-block-wrapper">
        <div className="mk-review-block d-flex align-items-start">
          <CircleImage className="circle-wrap circle-wrap-md bg-circle-dark text-white mk-name-abbr">
            {firstletter(value.cc_user_name)}
          </CircleImage>
          <div className="mk-review-content">
            <h1 className="mk-reviewer-name mb-1">{value.cc_user_name}</h1>
            <div className="mk-ratings-individual d-flex gap-2">
              <span className="d-flex gap-1 mk-stars">
              {iconStarfn(value.cc_rating)}
              </span>
              
              <span className="mk-rating-time">{changeDate(value.created_date)}</span>
            </div>
            <div className="mk-review-copy">
              <p>{value.cc_reviews}</p>
            </div>
          </div>
        </div>
        <div className="mk-comment-feeds d-flex justify-content-end">
          {/* <div className="d-flex align-items-center gap-3 mk-feeds-btns">
            <span className="mk-feed-title me-1">Helpful?</span>
            <div className="d-flex align-items-center gap-4">
              <span className="mk-feeds-thumbs me-1" onClick={() => thumbsuphandler("up")}>{thumbsUpIcon}</span>
              <span className="mk-feeds-thumbs mk-feeds-thumbsdown" onClick={() => thumbsuphandler("down")}>{thumbsUpIcon}</span>
            </div>
          </div> */}
        </div>
      </div>

      ))
      }

      {visibleButton && (<div className="d-flex justify-content-center"><button type="button" className="m-3 btn btn-secondary" onClick={loadMore}>Load More</button></div>)}
      
      {/* <div className="mk-review-block-wrapper">
        <div className="mk-review-block d-flex align-items-start">
          <CircleImage className="circle-wrap circle-wrap-md bg-circle-dark text-white mk-name-abbr">
            M
          </CircleImage>
          <div className="mk-review-content">
            <h1 className="mk-reviewer-name mb-1">Mathew Sebastian</h1>
            <div className="mk-ratings-individual d-flex gap-2">
              <span className="d-flex gap-1 mk-stars">{iconStar} {iconStar} {iconStar} {iconStar}</span>
              <span className="mk-rating-time">2 Weeks ago</span>
            </div>
            <div className="mk-review-copy">
              <p>Well I started as a total Newbie knowing nothing about programming and now working as a full time software engineer, thanks to this course for being the starting point of my career.</p>
            </div>
          </div>
        </div>
        <div className="mk-comment-feeds d-flex justify-content-end">
          <div className="d-flex align-items-center gap-3 mk-feeds-btns">
            <span className="mk-feed-title me-1">Helpful?</span>
            <div className="d-flex align-items-center gap-4">
              <span className="mk-feeds-thumbs me-1">{thumbsUpIcon}</span>
              <span className="mk-feeds-thumbs mk-feeds-thumbsdown">{thumbsUpIcon}</span>
            </div>
          </div>
        </div>
      </div> */}
      {/* <div className="mk-review-block-wrapper">
        <div className="mk-review-block d-flex align-items-start">
          <CircleImage className="circle-wrap circle-wrap-md bg-circle-dark text-white">
            S
          </CircleImage>
          <div className="mk-review-content">
            <h1 className="mk-reviewer-name mb-1">Sarrah Williams</h1>
            <div className="mk-ratings-individual d-flex gap-2">
              <span className="d-flex gap-1 mk-stars">{iconStar} {iconStar} {iconStar} {iconStar} {iconStar}</span>
              <span className="mk-rating-time">3 Weeks ago</span>
            </div>
            <div className="mk-review-copy">
              <p>Well I started as a total Newbie knowing nothing about programming and now working as a full time software engineer, thanks to this course for being the starting point of my career.</p>
            </div>
          </div>
        </div>
        <div className="mk-comment-feeds d-flex justify-content-end">
          <div className="d-flex align-items-center gap-3 mk-feeds-btns">
            <span className="mk-feed-title me-1">Helpful?</span>
            <div className="d-flex align-items-center gap-4">
              <span className="mk-feeds-thumbs me-1">{thumbsUpIcon}</span>
              <span className="mk-feeds-thumbs mk-feeds-thumbsdown">{thumbsUpIcon}</span>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
}

export default ReviewsAndRatings;
